import React, { useEffect, useState } from 'react'
import AdministrationTypesOfDocumentsView from '../../views/administration-types-of-documents/administration-types-of-documents.view'
import DocumentsType from './../../../services/documents-type.service'
import { LocalStorageService, QuestionnaireService, StatusApplicationTypeService } from '../../../services'
import { RegistrationValidator } from '../../../validators'
import { convertToStandarDate } from '../../../utils'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

const AdministrationTypeOfDocumentsAction = (props) => {

	let {
		location,
		history
	} = props

	const { t } = useTranslation()
	const validators = RegistrationValidator(t)

	const [showLoadingRequesting, setShowLoadingRequesting] = useState(false)
	const [showCompletedRequesting, setShowCompletedRequesting] = useState(false)
	const [showErrorRequesting, setShowErrorRequesting] = useState(false)
	const [messageError, setMessageError] = useState('')

	const [alerts, setAlerts] = useState([])
	const [gridAction, setGridAction] = useState('')
	const [selectedAlert, setSelectedAlert] = useState(null)
	const [formatVariables, setFormatVariables] = useState([])

	const [viewDeleteDialog, setViewDeleteDialog] = useState(false)
	const [viewReminders, setViewReminders] = useState(false)
	const [viewDocument, setViewDocument] = useState(false)
	const [viewDetails, setViewDetails] = useState(false)
	const [isLoading, setIsLoading] = useState(false)

	const apiUrl = process.env.REACT_APP_MIFIRMA_API
	const token = JSON.parse(localStorage.getItem('token'))?.idToken
	const documentsTypeService = new DocumentsType(apiUrl)
	const localStorageService = new LocalStorageService()
	const questionnaireService = new QuestionnaireService(apiUrl)
	const statusApplicationTypeService = new StatusApplicationTypeService(apiUrl)

	const preferredLanguage = localStorageService.getLocalStorageItem('preferredLanguage')
	const language = preferredLanguage || 'es'
	moment.locale(language)

	const dataProfileOption = [
		{
			name: t('configuration.AdministrationTypeDocuments.data.profile.no.profile'),
			key: null
		}
	]

	const [dataProfileOptions, setDataProfileOptions] = useState(dataProfileOption)

	const toggleLoadingRequesting = (value) => {
		setShowLoadingRequesting(value)
	}

	const toggleCompletedRequesting = (time, sendInbox, path) => {
		let sendTo = (path && path !== '') ? path : '/configuration'
		setShowCompletedRequesting(true)
		setTimeout(() => {
			setShowCompletedRequesting(false)
			if (sendInbox) {
				const locationState = location.state
				if (locationState && locationState.from) {
					history.push({
						pathname: locationState.from,
						state: locationState
					})
				} else {
					history.push(sendTo)
				}
			}
		}, time || 4000)
	}

	const toggleErrorRequesting = (message, time, sendInbox, path) => {
		let sendTo = (path && path !== '') ? path : '/configuration'
		setShowErrorRequesting(true)
		setMessageError(message || '')
		setTimeout(() => {
			setShowErrorRequesting(false)
			setMessageError('')
			if (sendInbox) {
				const locationState = location.state
				if (locationState && locationState.from) {
					history.push({
						pathname: locationState.from,
						state: locationState
					})
				} else {
					history.push(sendTo)
				}
			}
		}, time || 4000)
	}

	const toggleErrorRequestingFalse = () => {
		setShowErrorRequesting(false)
	}

	const loadTypeDocuments = async () => {
		try {
			setIsLoading(true)
			const typeDocuments = await documentsTypeService.getAllTypeDocuments(token)

			const formattedData = typeDocuments.data.map((doc) => {
				let variables = []
				if (doc.variables && doc.variables.length > 0) {
					variables = doc.variables.map(variable => {
						variable.modifyDate = (variable.updatedDate) ? convertToStandarDate(variable.updatedDate, language) : ''
						return variable
					})
				}

				const data = {
					id: doc.id,
					name: doc.infoType,
					document: {
						id: doc.id,
						name: doc.name,
						description: doc.description,
					},
					infoType: doc.infoType,
					iconTrashActive: !doc.isInUse,
					dataProfile: doc.dataProfile || '',
					variables
				}

				return data
			})

			setAlerts(formattedData)
		} catch (error) {
			setAlerts([])
			setMessageError(t('configuration.AdministrationTypeDocuments.error.get.type.documents'))
			setShowErrorRequesting(true)
		} finally {
			setIsLoading(false)
			setSelectedAlert(null)
			setViewDeleteDialog(false)
		}
	}

	useEffect(() => {
		loadTypeDocuments()
		getFormatVariables()
		getDataProfileTypes()
	}, [token])

	const getFormatVariables = async () => {
		try {
			const formatVariables = await questionnaireService.getAllFormatsForVariables(token)
			const formatVariablesBD = formatVariables || []
			setFormatVariables(formatVariablesBD)
		} catch (error) {
			setMessageError(t('configuration.AdministrationTypeDocuments.error.get.type.format.variables'))
			setShowErrorRequesting(true)
			setTimeout(() => {
				setShowErrorRequesting(false)
			}, 4000)
		}
	}

	const getDataProfileTypes = async () => {
		try {
			const dataProfileTypes = await statusApplicationTypeService.getStatusApplicationType(token, 'dataProfile')
			if (dataProfileTypes && dataProfileTypes.data && Number(dataProfileTypes.statusCode) === 200) {
				const newOptions = [...dataProfileOption]
				for (const dataProfile of dataProfileTypes.data) {
					const data = {
						name: t(`configuration.AdministrationTypeDocuments.data.profile.${dataProfile.key}`),
						key: dataProfile.key
					}

					newOptions.push(data)
				}
				setDataProfileOptions(newOptions)
			} else {
				setMessageError(t('configuration.AdministrationTypeDocuments.error.get.type.format.variables'))
				setShowErrorRequesting(true)
				setTimeout(() => {
					setShowErrorRequesting(false)
				}, 4000)
			}
		} catch (error) {
			setMessageError(t('configuration.AdministrationTypeDocuments.error.get.type.format.variables'))
			setShowErrorRequesting(true)
			setTimeout(() => {
				setShowErrorRequesting(false)
			}, 4000)
		}
	}

	const handleSumbitVariable = async ({ data, handleCloseModalAddDetails, cleanData, setErrorVariableName, variables, setVariablesGrid }) => {
		let msgError = (data && data.view === 'create') ? t('configuration.AdministrationTypeDocuments.error.create.variable') : t('configuration.AdministrationTypeDocuments.error.update.variable')

		const variableName = (data && data.variableName) ? data.variableName : ''
		let nameValid = validators.nameValidator(variableName)
		if ((variableName === null && variableName === '') || nameValid !== '') {
			setErrorVariableName(true)
			return
		}

		const paramsCreateUpdate = {
			variableId: (data && data.variableId) ? data.variableId : null,
			typeDocumentId: (data && data.typeDocumentSelectId) ? data.typeDocumentSelectId : 0,
			variableName: (data && data.variableName) ? data.variableName : '',
			typeData: (data && data.typeData) ? data.typeData : '',
			formatVariableKey: (data && data.formatVariableKey) ? data.formatVariableKey : null,
			dataProfile: (data && data.dataProfile) ? data.dataProfile : null,
			mandatory: (data && data.mandatory) ? data.mandatory : false,
			token
		}
		toggleLoadingRequesting(true)

		try {
			const upsertVariable = await documentsTypeService.createOrUpdateVariable(paramsCreateUpdate)
			if (upsertVariable && upsertVariable.data && Number(upsertVariable.statusCode) === 200) {
				let variablesUpdated = upsertVariable.data || variables

				variablesUpdated = variablesUpdated.map(vu => {
					vu.modifyDate = (vu.updatedDate) ? convertToStandarDate(vu.updatedDate, language) : ''
					return vu
				})

				let typeDocumentCopy = selectedAlert
				typeDocumentCopy.variables = variablesUpdated

				setVariablesGrid(variablesUpdated)
				setSelectedAlert(typeDocumentCopy)
				handleCloseModalAddDetails(false)
				cleanData()
				toggleLoadingRequesting(false)
				toggleCompletedRequesting(4000, false, '/')

			} else if (upsertVariable.statusCode && Number(upsertVariable.statusCode) === 409) {
				toggleLoadingRequesting(false)
				toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.variable.name.repeat'), 4000, false, '/')
			} else if (upsertVariable.statusCode && Number(upsertVariable.statusCode) === 410) {
				toggleLoadingRequesting(false)
				toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.variable.with.value'), 4000, false, '/')
			} else {
				toggleLoadingRequesting(false)
				toggleErrorRequesting(msgError, 4000, false, '/')

			}
		} catch (error) {
			toggleLoadingRequesting(false)
			toggleErrorRequesting(msgError, 4000, false, '/')
		}
	}

	const handleDeleteVariable = async ({ variable, handleCloseModalDelete, setVariablesGrid }) => {
		handleCloseModalDelete()
		toggleLoadingRequesting(true)
		try {
			const paramsDelete = {
				variableId: variable.id || 0,
				token
			}
			const variableDeleted = await documentsTypeService.deleteVariable(paramsDelete)
			if (variableDeleted && variableDeleted.data && Number(variableDeleted.statusCode) === 200) {
				let variablesUpdated = variableDeleted.data || []

				variablesUpdated = variablesUpdated.map(vu => {
					vu.modifyDate = (vu.updatedDate) ? convertToStandarDate(vu.updatedDate, language) : ''
					return vu
				})

				let typeDocumentCopy = selectedAlert
				typeDocumentCopy.variables = variablesUpdated

				setVariablesGrid(variablesUpdated)
				setSelectedAlert(typeDocumentCopy)
				toggleLoadingRequesting(false)
				toggleCompletedRequesting(4000, false, '/')

			} else if (variableDeleted.statusCode && Number(variableDeleted.statusCode) === 410) {
				toggleLoadingRequesting(false)
				toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.variable.with.value'), 4000, false, '/')
			} else {
				toggleLoadingRequesting(false)
				toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.delete.variable'), 4000, false, '/')

			}
		} catch (error) {
			toggleLoadingRequesting(false)
			toggleErrorRequesting(t('configuration.AdministrationTypeDocuments.error.delete.variable'), 4000, false, '/')
		}
	}

	return (
		<div className='standard-wrapper'>
			<AdministrationTypesOfDocumentsView
				isLoading={isLoading}
				toggleLoadingRequesting={toggleLoadingRequesting}
				toggleCompletedRequesting={toggleCompletedRequesting}
				toggleErrorRequesting={toggleErrorRequesting}
				toggleErrorRequestingFalse={toggleErrorRequestingFalse}
				showLoadingRequesting={showLoadingRequesting}
				showErrorRequesting={showErrorRequesting}
				showCompletedRequesting={showCompletedRequesting}
				messageError={messageError}
				alerts={alerts}
				selectedAlert={selectedAlert}
				setSelectedAlert={setSelectedAlert}
				viewDetails={viewDetails}
				setViewDetails={setViewDetails}
				viewReminders={viewReminders}
				setViewReminders={setViewReminders}
				viewDocument={viewDocument}
				setViewDocument={setViewDocument}
				viewDeleteDialog={viewDeleteDialog}
				setViewDeleteDialog={setViewDeleteDialog}
				setNameComponentUser={setGridAction}
				loadTypeDocuments={loadTypeDocuments}
				dataProfileOptions={dataProfileOptions}
				formatVariables={formatVariables}
				handleSumbitVariable={handleSumbitVariable}
				handleDeleteVariable={handleDeleteVariable}
			/>
		</div>
	)
}

export default AdministrationTypeOfDocumentsAction
